import { render, staticRenderFns } from "./ChampionshipStages.vue?vue&type=template&id=08a212b4&scoped=true&"
import script from "./ChampionshipStages.vue?vue&type=script&lang=js&"
export * from "./ChampionshipStages.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipStages.vue?vue&type=style&index=0&id=08a212b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a212b4",
  null
  
)

export default component.exports